import { gql } from '@apollo/client/core';

export const TestimonialQuery = gql`
  query Testimonial($sign: String!) {
    testimonial(sign: $sign) {
      id
      sign
      skills
      author {
        firstname
        lastname
      }
      requestor {
        firstname
        lastname
        slug
      }
      description
      state
    }
  }
`;
